var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#42A460"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3002 29.7595L29.22 41.558C28.6665 42.1473 27.769 42.1473 27.2153 41.558C26.6619 40.9684 26.6619 40.0127 27.2153 39.4234L38.2955 27.6249H33.5501C32.8045 27.6249 32.2002 26.9814 32.2002 26.1875C32.2002 25.3936 32.8045 24.7501 33.5501 24.7501H41.6501C42.3957 24.7501 43 25.3936 43 26.1875V34.8126C43 35.6065 42.3957 36.25 41.6501 36.25C40.9045 36.25 40.3002 35.6065 40.3002 34.8126V29.7595ZM18.6998 31.2405L29.78 19.442C30.3335 18.8527 31.231 18.8527 31.7847 19.442C32.3381 20.0316 32.3381 20.9873 31.7847 21.5766L20.7045 33.3751H25.4499C26.1955 33.3751 26.7998 34.0186 26.7998 34.8125C26.7998 35.6064 26.1955 36.2499 25.4499 36.2499H17.3499C16.6043 36.2499 16 35.6064 16 34.8125V26.1874C16 25.3935 16.6043 24.75 17.3499 24.75C18.0955 24.75 18.6998 25.3935 18.6998 26.1874V31.2405Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeGreen);
export default __webpack_public_path__ + "static/media/change-green.4646e3f7d9600ad34752b5a7a3daed84.svg";
export { ForwardRef as ReactComponent };